import { Flex, Select } from "@/atoms"
import { Form } from "@/organisms/Form/Form"
import { RemoveButton } from "@/organisms/Form/components/RemoveButton"
import { TagInput } from "@/organisms/Form/components/TagInput"

import type { FieldSpecificResourceProps } from ".."

export const FieldSpecificResource = (props: FieldSpecificResourceProps) => {
  const { form, name, path, componentProps, t } = props
  const { last, tForm, rules, options } = componentProps
  const values = form.getFieldValue(path)
  const type = values?.type
  const disabled = !type
  const currentField = options?.find((option) => option.value === type)
  const { placeholder, valueType, opts } = currentField || {}
  const showTagInput = disabled || valueType === "STRING_ARRAY_INPUT"

  return (
    <Flex gap={10}>
      <Flex flex={3}>
        <Form.Item name={[name, "type"]} rules={rules} data-testid="type">
          <Select options={options} placeholder={tForm("placeholder.select")} />
        </Form.Item>
      </Flex>
      <Flex flex={6}>
        <Form.Item name={[name, "value"]} rules={rules} data-testid="value">
          {showTagInput && (
            <TagInput disabled={disabled} placeholder={placeholder} />
          )}
          {(valueType === "SELECT" || valueType === "SELECT_ARRAY") && (
            <Select
              disabled={disabled}
              mode={valueType === "SELECT_ARRAY" ? "multiple" : undefined}
              placeholder={placeholder || t("general.select")}
              fieldNames={{ label: "displayName", value: "id" }}
              // Search by what is shown: the ids are opaque
              optionFilterProp="displayName"
              options={opts}
            />
          )}
        </Form.Item>
      </Flex>
      <RemoveButton disabled={last} name={name} remove={props.remove} />
    </Flex>
  )
}
